const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });
const relative = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

export const formatDateTime = (iso: string) => dateTime.format(new Date(iso));
export const formatDate = (iso: string) => date.format(new Date(iso));

export function formatRelative(iso: string): string {
  const diffSec = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diffSec);
  if (abs < 60) return relative.format(Math.round(diffSec), 'second');
  if (abs < 3600) return relative.format(Math.round(diffSec / 60), 'minute');
  if (abs < 86400) return relative.format(Math.round(diffSec / 3600), 'hour');
  return relative.format(Math.round(diffSec / 86400), 'day');
}

/** A short, human description of a browser user-agent string. */
export function describeUserAgent(ua: string | null): string {
  if (!ua) return 'Unknown device';
  const browser = /Edg\//.test(ua)
    ? 'Edge'
    : /Chrome\//.test(ua)
      ? 'Chrome'
      : /Firefox\//.test(ua)
        ? 'Firefox'
        : /Safari\//.test(ua)
          ? 'Safari'
          : 'Browser';
  const os = /Windows/.test(ua)
    ? 'Windows'
    : /Mac OS X/.test(ua)
      ? 'macOS'
      : /Android/.test(ua)
        ? 'Android'
        : /iPhone|iPad/.test(ua)
          ? 'iOS'
          : /Linux/.test(ua)
            ? 'Linux'
            : 'Unknown OS';
  return `${browser} on ${os}`;
}

const moneyFormats = new Map<string, Intl.NumberFormat>();
/**
 * Formats a decimal string in its currency, e.g. ("1499.5", "INR") → "₹1,499.50".
 * INR uses Indian digit grouping (₹4,07,095). `whole` drops the minor unit for headline figures.
 */
export function formatMoney(
  amount: string | null,
  currency: string,
  opts: { whole?: boolean } = {},
): string {
  if (amount === null) return '—';
  const key = `${currency}:${opts.whole ? 'w' : 'f'}`;
  let fmt = moneyFormats.get(key);
  if (!fmt) {
    const locale = currency === 'INR' ? 'en-IN' : undefined;
    const digits = opts.whole ? { maximumFractionDigits: 0, minimumFractionDigits: 0 } : {};
    try {
      fmt = new Intl.NumberFormat(locale, { style: 'currency', currency, ...digits });
    } catch {
      fmt = new Intl.NumberFormat(locale, { minimumFractionDigits: opts.whole ? 0 : 2 });
    }
    moneyFormats.set(key, fmt);
  }
  return fmt.format(Number(amount));
}

export function personName(
  p: { firstName: string | null; lastName: string | null; email: string | null } | null,
): string {
  if (!p) return 'Guest';
  const name = [p.firstName, p.lastName].filter(Boolean).join(' ');
  return name || p.email || 'Customer';
}
